import React from "react";

const Maps = () => {
  return <div>Maps</div>;
};

export default Maps;
